<template>
  <div>
    <div class="d-flex justify-end mb-2">
      <vue-json-to-csv
        :json-data="exportRows"
        :labels="exportLabels"
        :csv-title="exportFilename"
        separator=";"
      >
        <v-btn text small color="deep-purple lighten-1">
          <v-icon left small>mdi-download</v-icon>
          {{ $t('surveys.export.button') }}
        </v-btn>
      </vue-json-to-csv>
    </div>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1 text-center">
          <div class="text-caption grey--text text-uppercase">{{ $t('surveys.nps.score') }}</div>
          <div class="text-h3 font-weight-bold" :class="npsColor">
            {{ formatNps(results.npsScore) }}
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1 text-center">
          <div class="text-caption grey--text text-uppercase">
            {{ $t('surveys.nps.responses') }}
          </div>
          <div class="text-h3 font-weight-bold deep-purple--text">{{ results.n }}</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1 text-center">
          <div class="text-caption grey--text text-uppercase">{{ $t('surveys.nps.average') }}</div>
          <div class="text-h3 font-weight-bold amber--text text--darken-2">
            {{ formatScore(results.averageScore) }}
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1">
          <div v-for="row in classificationRows" :key="row.key" class="mb-1">
            <div class="d-flex justify-space-between text-caption">
              <span>{{ $t(`surveys.nps.${row.key}`) }}</span>
              <span class="grey--text">{{ row.count }} · {{ formatPct(row.pct) }}</span>
            </div>
            <v-progress-linear :value="row.pct" :color="row.color" height="10" rounded />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';
import { formatNpsScore, npsScoreColor, npsScoreTextClass } from '@/utils/nps';

export default {
  name: 'NpsKpis',
  components: { VueJsonToCsv },
  props: {
    results: { type: Object, required: true },
    campaignName: { type: String, default: '' },
  },
  computed: {
    classificationRows() {
      return [
        {
          key: 'promoters',
          count: this.results.promoters,
          pct: this.results.promotersPct,
          color: npsScoreColor(10),
        },
        {
          key: 'passives',
          count: this.results.passives,
          pct: this.results.passivesPct,
          color: npsScoreColor(8),
        },
        {
          key: 'detractors',
          count: this.results.detractors,
          pct: this.results.detractorsPct,
          color: npsScoreColor(0),
        },
      ];
    },
    npsColor() {
      return npsScoreTextClass(this.results.npsScore);
    },
    exportRows() {
      return [{
        npsScore: this.formatNps(this.results.npsScore),
        n: this.results.n,
        averageScore: this.formatScore(this.results.averageScore),
        promoters: this.results.promoters,
        promotersPct: this.formatPct(this.results.promotersPct),
        passives: this.results.passives,
        passivesPct: this.formatPct(this.results.passivesPct),
        detractors: this.results.detractors,
        detractorsPct: this.formatPct(this.results.detractorsPct),
      }];
    },
    exportLabels() {
      return {
        npsScore: { title: this.$t('surveys.nps.score') },
        n: { title: this.$t('surveys.nps.responses') },
        averageScore: { title: this.$t('surveys.nps.average') },
        promoters: { title: this.$t('surveys.nps.promoters') },
        promotersPct: { title: `${this.$t('surveys.nps.promoters')} %` },
        passives: { title: this.$t('surveys.nps.passives') },
        passivesPct: { title: `${this.$t('surveys.nps.passives')} %` },
        detractors: { title: this.$t('surveys.nps.detractors') },
        detractorsPct: { title: `${this.$t('surveys.nps.detractors')} %` },
      };
    },
    exportFilename() {
      return `kpis_${this.campaignName}_${new Date().toISOString().slice(0, 10)}`;
    },
  },
  methods: {
    formatNps: formatNpsScore,
    formatScore(value) {
      return Number(value || 0).toFixed(1);
    },
    formatPct(value) {
      return `${Math.round(value || 0)}%`;
    },
  },
};
</script>
